import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import style from './MiniOrdersTable.module.css';
import { cancelOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/orders/cancelOrder';
import { Body4 } from '../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../colorVars';
import determineSide from '../../../../../../../../utils/positions/DetermineSide';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { modifyOpenOrderLimitPrice } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/orders/modifyOpenOrderLimitPrice';
import { modifyOpenOrderQuantity } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/orders/modifyOpenOrderQuantity';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';

export const MiniOrderTableRow = observer(({ orderId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const order = tradePlanStore.orders.tradeUnafraid[orderId] ?? null;
  if (!order) return null;

  const updateLimitPrice = (newValue) => {
    modifyOpenOrderLimitPrice(order, newValue);
  };
  const updateQuantity = (newValue) => {
    modifyOpenOrderQuantity(order, newValue);
  };

  return (
    <tr>
      <td>
        <div className={style.cancelButtonWrapper}>
          <CancelOrderButton
            clickHandler={() => cancelOrder(order)}
            width={15}
          />
        </div>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>{determineSide(order.side)}</Body4>
      </td>
      <td>
        <EditableTableField
          bodySize={4}
          initialValue={order.quantity}
          updateValue={updateQuantity}
          backgroundColor="inherit"
          color={colors.lightGrey}
          inputType="number"
        />
      </td>
      <td>
        <EditableTableField
          bodySize={4}
          initialValue={ApplyRounding(order.price, 2)}
          updateValue={updateLimitPrice}
          backgroundColor="inherit"
          color={colors.lightGrey}
          inputType="number"
        />
      </td>
    </tr>
  );
});
